import { USState } from './mortgageRatesState';

const sanitizeAnchorHtml = (html: string): string => {
    let output = html;
    const emptyAnchorRe = new RegExp(
        '<a\\b(?:(?!\\b(?:id|name|href|data-|aria-)\\b)[^>])*>[\\s]*<\\/a>',
        'gi'
    );
    const nestedAnchorRe = new RegExp(
        '<a\\b[^>]*>\\s*<a\\b([^>]*)>([\\s\\S]*?)<\\/a>\\s*<\\/a>',
        'gi'
    );
    let prev = '';
    let guard = 0;
    do {
        prev = output;
        output = output.replace(emptyAnchorRe, '');
        output = output.replace(nestedAnchorRe, '<a$1>$2</a>');
        guard += 1;
    } while (output !== prev && guard < 10);
    return output;
};

const replaceStatePlaceholders = (obj: unknown, state: USState): unknown => {
    if (typeof obj === 'string') {
        const withState = obj
            .replace(/{State}/g, state.name)
            .replace(/{StateAbv}/g, state.abbreviation);
        return sanitizeAnchorHtml(withState);
    }

    if (Array.isArray(obj)) {
        return obj.map((item) => replaceStatePlaceholders(item, state));
    }

    if (obj && typeof obj === 'object') {
        const result = {};
        for (const [key, value] of Object.entries(obj)) {
            result[key] = replaceStatePlaceholders(value, state);
        }
        return result;
    }

    return obj;
};

const STATE_SCOPED_BLOCKS = ['zhl/zhl-rate-summary', 'zhl/zhl-rate-cards'];

// Rate widgets need the state even if editors drop the attr from the template.
const injectStateAttr = (block: unknown, state: USState): unknown => {
    if (!block || typeof block !== 'object') return block;

    const { blockName, attrs, innerBlocks } = block as {
        blockName?: string;
        attrs?: Record<string, unknown>;
        innerBlocks?: unknown[];
    };

    return {
        ...block,
        ...(STATE_SCOPED_BLOCKS.includes(blockName ?? '') && {
            attrs: { ...attrs, state: state.abbreviation },
        }),
        ...(Array.isArray(innerBlocks) && {
            innerBlocks: innerBlocks.map((inner) =>
                injectStateAttr(inner, state)
            ),
        }),
    };
};

/**
 * Template is authored in homeloans WordPress (post 3086) and fetched at
 * runtime; see mortgageRatesBlocks.ts.
 */
export const getMortgageRatesContent = (blocks: unknown[], state: USState) =>
    blocks.map((block) =>
        injectStateAttr(replaceStatePlaceholders(block, state), state)
    );
